const style = (theme) => {
  const output = {
    root: {
      display: 'block',
      fill: 'none',
      strokeWidth: 30,
      stroke: theme.colors[3],
    },
  }

  return output
}
export default style
